
define('tpl!taoQtiTest/runner/provider/layout', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<main class=\"test-runner-scope\">\n    <div class=\"action-bar content-action-bar horizontal-action-bar top-action-bar\">\n        <div class=\"control-box size-wrapper\"></div>\n    </div>\n\n    <div class=\"test-runner-sections\">\n\n        <aside class=\"test-sidebar test-sidebar-left\"></aside>\n\n        <section class=\"content-wrapper\">\n            <div id=\"qti-content\"></div>\n        </section>\n    </div>\n\n    <nav class=\"action-bar content-action-bar horizontal-action-bar bottom-action-bar\">\n        <div class=\"control-box size-wrapper\">\n            <div class=\"lft tools-box\"></div>\n            <div class=\"rgt navi-box\">\n                <ul class=\"plain navi-box-list\"></ul>\n            </div>\n        </div>\n    </nav>\n\n</main>\n";
  });
});

